import Api from "../api";
let uri = '/api/ed/subcategoria/';

export const getSubpilares = () => {
    return Api.getInstance().executeGetQuery(`${uri}`)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const adminSubpilar = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}



